import CollapsibleArrayFieldTemplate from "./CollapsibleArrayFieldTemplate";

export default CollapsibleArrayFieldTemplate;
